import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, timeout: 30000 });

export const formatTRY = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);

export const formatNumber = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(n || 0);

export const formatPct = (n) => `%${formatNumber(n)}`;
